import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const POC_OPERATIONAL_STATUS = gql`
  query sellerOperationalStatus {
    user {
      chatHashCode
    }
    seller {
      id
      name
      status
      address {
        city
        countryCode
        provinceCode
        neighborhood
      }
      document
    }
  }
`

export const POC_OPERATIONAL_STATUS_KEY = 'usePocOperationalStatus'

export const usePocOperationalStatus = () =>
  useQuery({
    queryKey: [POC_OPERATIONAL_STATUS_KEY],
    queryFn: variables => client.request(POC_OPERATIONAL_STATUS, variables),
  })
